import React from 'react';
import DocSvg from '../svg/DocSvg'
import ImageSvg from '../svg/ImageSvg';
import VideoSvg from '../svg/VideoSvg';
import AudioSvg from '../svg/AudioSvg';

import { useDropzone } from "react-dropzone";

export function DropDocs({ onDrop, accept }) {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept
    });

    return (
        <div {...getRootProps()}>
            <input className="dropzone-input" {...getInputProps()} />
            <DocSvg />
            <span className='text-xs text-gray-100 leading-4 mt-3'> Document </span>
        </div>
    );
};

export function DropImage({ onDrop, accept }) {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept
    });

    return (
        <div {...getRootProps()}>
            <input className="dropzone-input" {...getInputProps()} />
            <ImageSvg />
            <span className='text-xs text-gray-100 leading-4 mt-3'> Images </span>
        </div>
    );
};

export function DropVideo({ onDrop, accept }) {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept
    });

    return (
        <div {...getRootProps()}>
            <input className="dropzone-input" {...getInputProps()} />
            <VideoSvg />
            <span className='text-xs text-gray-100 leading-4 mt-3'> Video </span>
        </div>
    );
};

export function DropAudio({ onDrop, accept }) {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept
    });

    return (
        <div {...getRootProps()}>
            <input className="dropzone-input" {...getInputProps()} />
            <AudioSvg />
            <span className='text-xs text-gray-100 leading-4 mt-3'> Audio </span>
        </div>
    );
};